// extracted by mini-css-extract-plugin
export var createdDate = "_kx-1";
export var divider = "_kx-2";
export var headerDivider = "_kx-3";
export var messagesCard = "_kx-0";
export var messagesContainer = "_kx-6";
export var messagesContainerWrapper = "_kx-4";
export var showLeftPanelButton = "_kx-8";
export var topButtons = "_kx-7";
export var withPadding = "_kx-5";